<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div
            class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
            <div class="d-sm-flex align-items-center">
                <a class="btn btn-secondary" @click="generateCSV">
                    <i class="fa fa-plus-circle"></i>
                    Télécharger Model
                </a>
            </div>
            <div class="d-flex align-items-center">
                <input type="file" class="form-control" @change="lireCSVConvertirEnCsv($event)" accept=".csv" />
                <button class="btn btn-primary" @click="importer">Importer</button>
            </div>
        </div>
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="table-responsive">
          <table class="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                 Nom
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                 Prenom
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                 Email
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                 Telephone
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                 NPI
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                 IFU
                </th>
                <th
                  v-show="aMotif"
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                 Motif
                </th>
    
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0  pe-0"
                >ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(usager, index) in usagers" :key="index">
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ usager.nom}}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ usager.prenom }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ usager.email }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ usager.numTel }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ usager.npi }}
                </td>
                <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ usager.ifu }}
                </td>
                <td v-show="aMotif" class="shadow-none lh-1 fw-medium text-black-emphasis">
                  {{ usager.motif }}
                </td>
                <td
                  class="shadow-none lh-1 fw-medium text-body-tertiary pe-0"
                >
                <div class="shadow-none lh-1 fw-medium text-black pe-0 text-end">
                  <button class="btn btn-sm btn-primary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Actions
                  </button>
                    <ul class="dropdown-menu">
                      <li>
                        <a
                          class="dropdown-item d-flex align-items-center" href="javascript:void(0);" @click="suppression(usager.email,usagers)">
                          <i class="flaticon-delete lh-1 me-8 position-relative top-1" ></i>
                           Supprimer
                        </a>
                      </li>
                    </ul>
                </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center"
        >
          <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
        </div>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent, onMounted, ref} from "vue";
  import Swal from "sweetalert2";
  import { Usager } from "@/models/Usager";
  import ApiService from "@/services/ApiService";
  import { suppression, error, success } from "@/utils/utils";
  import PaginationComponent from '@/components/Utilities/Pagination.vue';
  import JwtService from "@/services/JwtService";
import axios from "axios";
import router from "@/router";
  
  export default defineComponent({
    name: "ImportationUsager",
    components: {
      PaginationComponent
    },
    setup(){
        const usagers = ref<Array<any>>([]);
        const page = ref<number>(1);
        const limit = ref<number>(10);
        const totalPages = ref<number>(1);
        const totalElements = ref<number>(0);

        const generateCSV = () => {
            const headers = ["nom", "prenom", "email", "sexe", "numTel", "npi", "ifu"];
            const rows = usagers.value.map(usager => [
            usager.nom,
            usager.prenom,
            usager.email,
            usager.sexe,
            usager.numTel,
            usager.npi,
            usager.ifu
            ]);

            let csvContent = "data:text/csv;charset=utf-8,"
                + headers.join(";") + "\n"
                + rows.map(e => e.join(";")).join("\n");

            const encodedUri = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "FichierModel.csv");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        };

        const aMotif = ref(false);

        const privileges = ref<Array<string>>(JwtService.getPrivilege());
        const checkPermission = (name) => {
            return privileges.value.includes(name);
        }
        const importer = async () => {
            // Add your import logic here
            console.log("Importing...");

            

            if (usagers.value.length < 1) {
                Swal.fire({
                    icon: 'error',
                    title: 'Erreur',
                    text: 'La liste des usagers est vide',
                });
                return;
            }

            try {
                const response = await axios.post(`importation/usager`, usagers.value);
                console.log("Réponse  ==> ", response)
                if (response.status === 200) {
                    success(response.data.message)
                    const retour = response.data.data;
                    usagers.value = [];
                    if(retour.length > 0){
                        aMotif.value = true;
                        usagers.value = retour;
                        Swal.fire({
                            icon: 'error',
                            title: 'Erreur',
                            text: 'Retrouvez dans le tableau la liste des places non enregistrées et le motif correspondant',
                        }); 
                    }else{
                      router.push('/liste-usager');
                    }
                    
                } else {
                  error("Une erreur est survenue lors de l'importation")
                }
            } catch (erre) {
                console.log("Erreur  ==> ", erre)
            }
           

        };

        const suppression = (code: string, element: any) => {
            Swal.fire({
              html: `<span> Vous êtes sur le point de supprimer la place ayant le code <strong style="color:red;"> ` + code + `. </strong> Etes-vous sûr ?</span>`,
              icon: "warning",
                buttonsStyling: true,
                showCancelButton: true,
                confirmButtonText: "Retirer",
                cancelButtonText: `Annuler`,
                heightAuto: false,
                customClass: {
                    confirmButton: "btn btn-danger",
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    for (let i = 0; i < element.length; i++) {
                        if (element[i].email === code) {
                            element.splice(i, 1);
                        }
                    }
                    Swal.fire({
                        title: 'Succès',
                        text: "Elément retiré du tableau",
                        icon: "success",
                        toast: true,
                        timer: 5000,
                        position: 'top-right',
                        showConfirmButton: false,
                    });
                } else if (result.isDenied) {
                    Swal.fire("La suppression n'est pas passée", "", "info");
                }
            });
        };

        const handlePaginate = (newPage: number) => {
            page.value = newPage;
        };

        const lireCSVConvertirEnCsv = async (event) => {
            const file = (event.target as HTMLInputElement)?.files?.[0];
            if (!file || file.type !== "text/csv") {
                Swal.fire({
                    icon: 'error',
                    title: 'Erreur',
                    text: 'Veuillez télécharger un fichier CSV.',
                });
                (event.target as HTMLInputElement).value = '';
                return;
            }

            const requiredHeaders = ["nom", "prenom", "email", "sexe", "numTel", "npi", "ifu"];
            const reader = new FileReader();
            reader.onload = (event: any) => {
                const csv = event.target.result;
                const lines = csv.split("\n");
                const headers = lines[0].split(";");
                const cleanedHeaders = headers.map(header => header.trim());
                console.log("Entête ===> ", cleanedHeaders);

                const missingHeaders = requiredHeaders.filter(cleanedHeaders => !cleanedHeaders.includes(cleanedHeaders));
                if (missingHeaders.length > 0) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Erreur',
                        text: `Les en-têtes suivantes sont manquantes: ${missingHeaders.join(", ")}`,
                    });
                    (event.target as HTMLInputElement).value = '';
                    return;
                }

                const result: Array<Record<string, any>> = [];
                for (let i = 1; i < lines.length; i++) {
                    const obj: any = {};
                    const currentline = lines[i].split(";");
                    const cleanedLine = currentline.map(current => current.trim());

                    console.log("currentline ==> ", currentline)
                    for (let j = 0; j < headers.length; j++) {
                        obj[headers[j].trim()] = currentline[j] ? (currentline[j]).toString().trim() : "";
                    }
                    if(obj.email && obj.email != ""){
                      result.push(obj);
                    }
                }
                totalElements.value = result.length;
                usagers.value = result;
            };
            reader.readAsText(file, 'ISO-8859-1');


        };

        return {
            aMotif,
            usagers,
            lireCSVConvertirEnCsv,
            importer,
            suppression,
            totalElements,
            totalPages,
            page,
            limit,
            handlePaginate,
            generateCSV,
        };
    },
  });
  </script>